import abilitiesApiService from '@/services/api/Abilities'

const emptyModel = {
  name: null,
  title: null,
  entity_id: null,
  entity_type: null,
  only_owned: null,
  options: null,
  scope: null
}

const emptyFilters = {
  name: null,
  title: null
}

class Ability {
  constructor() {
    this.api = abilitiesApiService
    this.emptyModel = emptyModel
    this.emptyFilters = emptyFilters
  }
}

let ability = new Ability()

export default ability
